import { DeleteResponse } from '@customTypes/api/Notification';
import { Endpoints, KrakendServiceAPI } from '@service/index';
import { useMutation } from 'react-query';

const useDeleteNotification = () => {
  return useMutation((notificationIds: string[]) => {
    return KrakendServiceAPI.delete<
      { notification_ids: string[] },
      DeleteResponse
    >(Endpoints.Notification(), {
      notification_ids: notificationIds,
    });
  });
};

export default useDeleteNotification;
